/**
 * [INPUT]: 依赖游戏封面槽位、变体类型、API origin 与旧 cover_url 兼容地址。
 * [OUTPUT]: 对外提供 hero/card/thumb 的稳定回退顺序、服务端相对图片解析和游戏封面选择器。
 * [POS]: admin-web 游戏展示规则层；目录、详情与编辑预览共享同一套封面选择语义，图片来源与 server 目录保持一致。
 * [PROTOCOL]: 变更时更新此头部，然后检查 CLAUDE.md
 */
import type { GameCoverSlot, GameCoverVariants, GameSummary } from '../types';
import { apiOrigin } from './api-config';

export const COVER_FALLBACK_ORDER: Record<GameCoverSlot, readonly GameCoverSlot[]> = {
  hero: ['hero', 'card', 'thumb'],
  card: ['card', 'hero', 'thumb'],
  thumb: ['thumb', 'card', 'hero'],
};

export type GameCoverSources = Partial<Record<GameCoverSlot, string | null | undefined>>;

export function selectCoverUrl(slot: GameCoverSlot, sources: GameCoverSources, legacyCoverUrl?: string | null): string {
  for (const candidate of COVER_FALLBACK_ORDER[slot]) {
    const url = sources[candidate]?.trim();
    if (url) return resolveCoverUrl(url);
  }
  return resolveCoverUrl(legacyCoverUrl?.trim() ?? '');
}

export function resolveCoverUrl(url: string): string {
  if (!url || /^(?:https?:|data:|blob:)/i.test(url)) return url;
  return url.startsWith('/') ? `${apiOrigin}${url}` : url;
}

export function selectGameCover(game: Pick<GameSummary, 'cover' | 'coverVariants'>, slot: GameCoverSlot): string {
  return selectCoverUrl(slot, variantSources(game.coverVariants), game.cover);
}

export function variantSources(variants: GameCoverVariants): GameCoverSources {
  return {
    hero: variants.hero?.url,
    card: variants.card?.url,
    thumb: variants.thumb?.url,
  };
}
